// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1r9lg","info":"UpdateTermsInfo_info__13bu6"};